<template>
  <div class="info">
    <b-container>
      <sectionHeader ref="dynateam" :text="dynateam.header" />
      <sectionSummary :text="dynateam.summary" />
      <ulList :header="dynateam.listHeader" :list="dynateam.list" />

      <hr />

      <customers ref="customers" :language="language"/>
    </b-container>
  </div>
</template>

<script>
import sectionHeader from '../text/SectionHeader'
import sectionSummary from '../text/SectionSummary'
import sectionText from '../text/SectionText'
import ulList from '../list/ULList'
import customers from './Customers'

const ABOUTID = 8
const DYNATEAMID = 9

export default {
  name: 'info',
  props: {
    section: {
      type: String,
      default: 'none'
    },
    language: {
      type: String
    }
  },
  components: {
    sectionHeader,
    sectionSummary,
    sectionText,
    ulList,
    customers
  },
  data () {
    return {
      about: {
        summary: '',
        text: ''
      },
      dynateam: {
        header: '',
        summary: '',
        listHeader: '',
        list: {}
      }
    }
  },
  watch: {
    section: function () {
      this.scrollTo()
    },
    language: function () {
      this.handleLanguage()
    }
  },
  created: function () {
    this.handleLanguage()
  },
  mounted: function () {
    this.scrollTo()
  },
  methods: {
    handleLanguage: function () {
      this.about.summary = this.$root.getSummary(ABOUTID)
      this.about.text = this.$root.getText(ABOUTID)
      this.dynateam = {
        header: this.$root.getHeader(DYNATEAMID),
        summary: this.$root.getSummary(DYNATEAMID),
        listHeader: this.$root.getCategoryListHeader(DYNATEAMID, 0),
        list: this.$root.getCategoryList(DYNATEAMID, 0),
      }
    },
    scrollTo: function () {
      var navbarHeight = 50
      switch (this.section.toLowerCase()) {
        case 'customers':
          this.$refs.customers.$el.scrollIntoView()
          window.scroll(0, window.scrollY - navbarHeight)
          break
        case 'dynateam':
          this.$refs.dynateam.$el.scrollIntoView()
          window.scroll(0, window.scrollY - navbarHeight)
          break
        default:
          this.$el.scrollIntoView()
          break
      }
    }
  }
}
</script>

<style scoped>

.dynateam {
  background: url('./assets/Dynateam.jpg') no-repeat 0% 0%;
  background-size: cover;

  box-shadow: 0px 0px 15px 1px #000000;
}

</style>



// WEBPACK FOOTER //
// src/components/about/Info.vue